jQuery(document).ready(function ($) {
    function expireSubmissionCookie() {
        document.cookie = 'arise_pc_submission=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
    }

    window.addEventListener('pagehide', expireSubmissionCookie);
    window.addEventListener('beforeunload', expireSubmissionCookie);

    $(document).ajaxSuccess(function (event, xhr) {
        const nonce = xhr && xhr.responseJSON && xhr.responseJSON.data && xhr.responseJSON.data.nonce;

        if (nonce) {
            arise_pc.nonce = nonce;
        }
    });
});
